import { TextBody2, TextBody3, TextNote1 } from "common/components";
import { Column, Row } from "common/components/Layout/new/constLayout";
import { colors } from "common/const/colors";
import { NotificationType } from "common/enum/NotificationType";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { apiRequest } from "common/utils/api";
import styled from "styled-components";

export const NotificationItem = ({ notificationInfo }) => {
  const infoTextColor =
    notificationInfo.type === NotificationType.CHANGE_PASSPORT
      ? colors.Forest
      : colors.Salmon;

  return (
    <Row
      style={{
        padding: "1rem",
        gap: "0.75rem",
        cursor: "pointer",
        opacity: notificationInfo.isRead ? 0.25 : 1,
      }}
      onClick={() => {
        console.log(notificationInfo.id);
        apiRequest({
          method: REQUEST_METHOD.PUT,
          url: `/api/v1.0/notifications/${notificationInfo.id}/read`,
        });
        sessionStorage.setItem("clubId", notificationInfo.clubId);
        window.location = notificationInfo.redirectUrl;
      }}>
      <NotificationStatusBar color={notificationInfo.type || colors.Gray} />
      <Column style={{ gap: "4px" }}>
        <TextBody3>{notificationInfo?.title}</TextBody3>
        <Column style={{ gap: 0 }}>
          <TextBody2>{notificationInfo?.content}</TextBody2>
          {notificationInfo?.info && (
            <TextBody3 color={infoTextColor}>{notificationInfo.info}</TextBody3>
          )}
        </Column>
        <TextNote1 color={colors.LightNavy}>
          {notificationInfo?.createdAt}
        </TextNote1>
      </Column>
    </Row>
  );
};

const NotificationStatusBar = styled.div`
  width: 0.25rem;
  align-self: stretch;
  background-color: ${({ color }) => color};
`;
